<template>
  <div v-if="object && dataReady" style="width: 99%">
    <div class="row" style="background: #c9c9c9">
      <div class="col-md-11" style="text-align: left">
        <i class="tim-icons icon-simple-remove" v-on:click="toView" style="margin-right: 10px"></i>
        <b>Новый документ</b>
      </div>
      <div class="col-md-1" style="text-align: right">
        <i v-if="!inSave" class="tim-icons icon-check-2" v-on:click="save" style="margin-right: 10px"></i>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <base-input label="Название документа"
                    v-model="object.name">
        </base-input>
      </div>
      <div class="col-md-6">
        <base-input label="Дата"
                    v-model="object.date"
                    :value="object.date"
                    :date="true"
        ></base-input>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <list-option :label="'Тип документа'" :object="object" :field="'pattern'"
                     :name="'name'" :objects="patterns" :value="'value'">
        </list-option>
      </div>
    </div>

    <div v-if="object.fields && object.fields.length > 0" :key="fieldsKey">
      <br/>
      <div v-for="(item, index) in object.fields" :key="index" style="vertical-align: bottom" class="row">
        <div class="col-8">
          <base-input :label="getPatternDescription(item.attr)"
                      v-model="item.value">
          </base-input>
        </div>
        <div class="col-4">
          <base-button style="margin-top: 1.8rem" @click="updateValue(index)" :size="'sm'" type="info" fill>Обновить</base-button>
          <base-button v-if="item.sourceType !== 'DATA' && item.sourceType !== 'CURRENT'"
                       style="margin-top: 1.8rem; margin-left: 2rem" @click="selectData(index)"
                       :size="'sm'" type="info" fill>
            Выбор данных
          </base-button>
        </div>
      </div>
    </div>

    <base-button style="margin-top: 1.8rem" @click="updateAll" :size="'sm'" type="info" fill>Обновить поля</base-button>

    <inv-select-modal :items="items" :field="field" :index="this.selectIndex"
                      @close="closeSelectModal" @select="updateDataSource">
    </inv-select-modal>

  </div>
</template>
<script>

 import SimpleRow from "@/components/SimpleRow";
 import BaseInput from "@/components/Inputs/BaseInput";
 import BaseCheckbox from "@/components/BaseCheckbox";
 import {longAsStringDate} from "@/services/utils";
 import {authHeader} from "@/services/auth-header";
 import {userService} from "@/services/user.service";

 export default {
   components: {
     SimpleRow,
     BaseInput,
     BaseCheckbox
   },
   props:{
     item: {},
     index: null,
     type: null
   },
   data() {
     return {
       socket: null,
       object: null,
       inSave: false,
       dataReady: false,
       patterns: [],
       fieldsKey: 0,
       items: [],
       field: {},
       selectIndex: 0
     }
   },
   methods: {
     convertDate(time) {
       return time ? longAsStringDate(time) : "-";
     },
     fieldView(data) {
       return data ? data : '-';
     },
     toView() {
       this.$emit('toView');
     },
     setPattern(pattern) {
       this.object.pattern = pattern.value;
     },
     async save() {
       if (this.object.name && this.object.name.length > 4 && this.object.pattern) {
         this.inSave = true;
         try {
           let renewed = await this.$repo.save(this.object, this.type);
           if (renewed) {
             this.item.object = renewed;
             this.item.id = renewed.id;
             this.$emit("updated", this.item.object)
             this.object = JSON.parse(JSON.stringify(renewed));
             this.inSave = false;
             this.toView();
           }
         } catch(error) {
           this.inSave = false;
         }
       }
     },
     getPatternDescription(attr) {
       for (let field of this.object.pattern.fields) {
         console.log(field['attribute'])
         if (field['attribute'] === attr) {
           return field.entity + ': ' + field.link;
         }
       }
       return "не известное поле"
     },
     async updateValue(index) {
       let val = await this.$repo.saveByLink(this.object.fields[index], 'document/refresh/' + this.object.id);
       if (val) {
         this.object.fields[index].value = val;
       }
     },
     async selectData(index) {
       let val = await this.$repo.saveByLink(this.object.fields[index], 'document/selectData/' + this.object.id);
       this.items = val;
       this.field = this.object.fields[index];
       this.selectIndex = index;
       await this.callSelectModal();
       if (val) {
        // this.object.fields[index].value = val[0].value;
       }
     },
     async updateAll() {
       let fields = await this.$repo.getByURL('document/updateFields/' + this.object.id);
       this.object.fields = fields;
       this.fieldsKey++;
     },
     async updateDataSource(idIndex) {
       this.object.fields[idIndex.index].sourceId = idIndex.id;
       await this.updateValue(idIndex.index);
       await this.closeSelectModal();
     },
     async callSelectModal() {
      let selectModal = await document.getElementById('INV_SELECT_MODAL');
      if (selectModal) {
        selectModal.style.display = "block";
      }
     },
     async closeSelectModal() {
       let selectModal = await document.getElementById('INV_SELECT_MODAL');
       if (selectModal) {
         selectModal.style.display = "none";
       }
     }
   },
   async mounted() {
     this.object = JSON.parse((JSON.stringify(this.item.object)));
     this.patterns = await this.$repo.getSelector('doc_pattern/list/' + this.object.ownerId.split('-')[0]);
     this.patterns.forEach(pattern => pattern.name = pattern.value.name + ' (' + longAsStringDate(pattern.value.creationDate) + ')');
     this.dataReady = true;
   }
 }
</script>
